export { default } from './CountryFlag';
